import { Divider, ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledDivider = styled(Divider)`
  width: 100%;
  border-color: ${(props: ThemeProps) => props.theme.mbColors.lightGray};
  border-top: none;
  margin: 0;
`
